import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { getPages, getTranslation } from '@/store/getters'
import { setActiveElement } from '@/store/actions'

import styles from './styles.scss'

/** Components */
import Button from '@/components/Button'

class Actions extends Component {
  handlePublish = (e) => {
    e.preventDefault()

    const { id_magazine, setActiveElement } = this.props

    setActiveElement(null)

    setTimeout(() => {
      window.open(`/publish/${id_magazine}`, '_blank')
    }, 1000)

  }

  render() {
    const { translation, } = this.props

    return (
      <div className={styles['wrapper-actions']}>
        <Link
          to='#'
          target="blank"
          data-ba-i="magazine-publish-magazine"
          onClick={this.handlePublish}
        >
          <Button color="success">
            {translation('action-publish-only')}
          </Button>
        </Link>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  const firstPage = getPages(state)[0]
  const id_magazine = firstPage ? firstPage.id_magazine : null
  return {
    translation,
    id_magazine,
  }
}

export default withRouter(connect(
  mapStateToProps,
  {
    setActiveElement
  }
)(Actions))



// WEBPACK FOOTER //
// ./src/components/Heade/components/Actions/index.js